// extracted by mini-css-extract-plugin
module.exports = {"serviceInfoBox":"serviceInfoBox--yL6UO","confirmTitle":"confirmTitle--vyfpy","confirmSubTitle":"confirmSubTitle--HmZER"};